// extracted by mini-css-extract-plugin
module.exports = {"title":"TrainingACN2_title_Y4kdO","video":"TrainingACN2_video_2UHDQ","note":"TrainingACN2_note_2gfCK"};